import React from 'react';
import styled from 'styled-components';

import STYLES from './styles';
import { WisedocLogo2 } from '.';
import { routes } from '../../../../../utilities/constants';
import { WhiteLogo } from '../../../../../../cra/src/components/userDocuments/editDocument/editJournal/toolset/assets/icons';
import breakpointsMinWidth from '../../../../../../cra/src/styling/breakpointsMinWidth';
import { cleanPathname, featurePages } from '../../../../../constants/navbar';

export const PurpleLogo = styled.img`
  width: ${({ width }) => width || '148.8px'};
`;

const LogoWrap = styled.div`
  svg {
    width: 148px;
    height: 32px;

    @media ${breakpointsMinWidth.desktopMd} {
      width: 204px;
      height: 44px;
    }
  }
`;
const PurpleLogoWrap = styled.div`
  img {
    width: 148px;
    height: 32px;

    @media ${breakpointsMinWidth.desktopMd} {
      width: 204px;
      height: 44px;
    }
  }
`;

const SVGLogo = (props) => {
  const { pathname, isTop, appType } = props;
  const isFeaturePage =
    appType !== 'CRA' &&
    featurePages.includes(cleanPathname(pathname)) &&
    pathname !== '/';
  let src = '/trademark-logo.png';
  if (appType === 'CRA') src = `/assets${src}`;

  let fill;
  let fillOpaq;
  if (isTop && (pathname === '/about-us' || pathname === '/about-us/')) {
    fill = 'rgba(255,255,255,1)';
    fillOpaq = 'rgba(255,255,255,0.73)';
  }

  const logoColor = pathname === '/about-us' || pathname === '/about-us/';
  const isEditor = pathname.includes('/documents/');
  const smallScreenSrc = 'https://gatsby.wisedoc.net/Wisedoc-Mobile-Logo.png';

  const routesToCheck = [
    routes.DRIVE,
    routes.ACCOUNT,
    routes.SUPPORT,
    routes.BILLINGS,
    routes.IRIS,
  ];
  const isPathIncluded =
    pathname && routesToCheck.some((route) => pathname.includes(route));

  const getPurpleLogo = () => {
    if (!isPathIncluded)
      return (
        <PurpleLogoWrap>
          <PurpleLogo src={src} alt="Wisedoc Logo" />
        </PurpleLogoWrap>
      );

    return (
      <div>
        <div className="hidden tabletSm:block">
          <PurpleLogo src={src} alt="Wisedoc Logo" />
        </div>
        <div className="block tabletSm:hidden">
          <PurpleLogo width="36px" src={smallScreenSrc} alt="Wisedoc Logo" />
        </div>
      </div>
    );
  };
  return (
    <>
      {isEditor && <WisedocLogo2 width="28px" />}

      {isTop && logoColor && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="140px"
          height="30px"
          viewBox="0 0 159.34 34.25"
          fill={fill}
          className="wisedoc"
        >
          <defs>
            <style>
              .cls-1 {STYLES.csl1}
              .cls-2 {STYLES.csl2}
            </style>
          </defs>
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <path
                className="cls-1"
                d="M61.14,11.12a2.16,2.16,0,0,0-1.74-.88,2.21,2.21,0,0,0-2.11,1.64L54.42,22.67,51.27,11.83a2.2,2.2,0,0,0-2.09-1.59h-.91a2.18,2.18,0,0,0-2.09,1.58L43,22.67,40.15,11.89A2.19,2.19,0,0,0,38,10.24h-.6a2.31,2.31,0,0,0-1.59,2.82L40.28,28.4A2.19,2.19,0,0,0,42.38,30h.71a2.16,2.16,0,0,0,2.08-1.55l3.5-11.34,3.51,11.34A2.16,2.16,0,0,0,54.26,30H55a2.2,2.2,0,0,0,2.1-1.59L61.5,13.06A2.21,2.21,0,0,0,61.14,11.12Z"
              />
              <path
                className="cls-1"
                d="M62.62,4.41a2.85,2.85,0,0,1,.75-2,2.39,2.39,0,0,1,1.88-.84,2.59,2.59,0,0,1,1.92.8,2.75,2.75,0,0,1,.78,2,2.74,2.74,0,0,1-.78,2,2.55,2.55,0,0,1-1.92.8,2.39,2.39,0,0,1-1.88-.84A2.83,2.83,0,0,1,62.62,4.41Zm.9,6.35h3.53a.33.33,0,0,1,.31.35v18a.33.33,0,0,1-.31.35H63.52a.33.33,0,0,1-.31-.35v-18A.33.33,0,0,1,63.52,10.76Z"
              />
              <path
                className="cls-1"
                d="M79.13,15.51a.3.3,0,0,1-.45,0,5.28,5.28,0,0,0-1.32-1.14,3.84,3.84,0,0,0-2.11-.61,3.67,3.67,0,0,0-1.83.47,1.65,1.65,0,0,0-.83,1.56,1.57,1.57,0,0,0,.92,1.54,15.8,15.8,0,0,0,2.68.92,12.91,12.91,0,0,1,1.88.62,6.55,6.55,0,0,1,1.73,1,4.87,4.87,0,0,1,1.26,1.6,5,5,0,0,1,.49,2.32A6.71,6.71,0,0,1,81,26.69a5.42,5.42,0,0,1-1.52,1.93,6.19,6.19,0,0,1-2.22,1.07,10.26,10.26,0,0,1-2.61.33,9.39,9.39,0,0,1-3.77-.8,8,8,0,0,1-2.82-2,.41.41,0,0,1,0-.52l2.25-2.38a.29.29,0,0,1,.46,0,5.91,5.91,0,0,0,1.59,1.38,4.66,4.66,0,0,0,2.45.66,4.2,4.2,0,0,0,.92-.11,2.87,2.87,0,0,0,.86-.37,1.85,1.85,0,0,0,.64-.69,2,2,0,0,0,.25-1,1.74,1.74,0,0,0-1-1.67,14.25,14.25,0,0,0-2.86-1,12.92,12.92,0,0,1-1.82-.6,5.77,5.77,0,0,1-1.57-1,4.45,4.45,0,0,1-1.11-1.5,5.4,5.4,0,0,1-.41-2.22,5.9,5.9,0,0,1,.57-2.69,5.37,5.37,0,0,1,1.5-1.85,6.47,6.47,0,0,1,2.11-1.07,8.31,8.31,0,0,1,2.43-.36,9.13,9.13,0,0,1,3.51.71,5.92,5.92,0,0,1,2.51,1.87.39.39,0,0,1,0,.51Z"
              />
              <path
                className="cls-1"
                d="M98.76,20.35V21q0,.32,0,.63H86.1a5.1,5.1,0,0,0,.47,1.85,4.61,4.61,0,0,0,1.05,1.44,5.21,5.21,0,0,0,1.49,1,4.46,4.46,0,0,0,1.73.35,5.12,5.12,0,0,0,2.63-.64,5,5,0,0,0,1.24-1,.82.82,0,0,1,1.21-.11l1.37,1.23a1.12,1.12,0,0,1,.1,1.48A8,8,0,0,1,90.88,30a9.23,9.23,0,0,1-3.57-.68,8.49,8.49,0,0,1-2.82-1.93,8.7,8.7,0,0,1-1.86-3.06A11.75,11.75,0,0,1,82,20.23a12,12,0,0,1,.68-4.11A9.32,9.32,0,0,1,84.48,13a8.19,8.19,0,0,1,2.78-2,8.41,8.41,0,0,1,3.48-.73,7.89,7.89,0,0,1,3.2.65,6.93,6.93,0,0,1,2.54,1.91,9.31,9.31,0,0,1,1.68,3.16A14.63,14.63,0,0,1,98.76,20.35Zm-4.15-2.1a6.49,6.49,0,0,0-.22-1.72,4,4,0,0,0-.71-1.44,3.64,3.64,0,0,0-1.23-1,4,4,0,0,0-1.75-.37A4.37,4.37,0,0,0,87.54,15a4.83,4.83,0,0,0-1.44,3.26Z"
              />
              <path
                className="cls-1"
                d="M116.62,29.47h-1.86a1.11,1.11,0,0,1-1-1.18v-.54a1,1,0,0,1-.35.62,5.19,5.19,0,0,1-3,1.49,14,14,0,0,1-2.24.16,8.23,8.23,0,0,1-2-.22,6.67,6.67,0,0,1-1.54-.58A7.9,7.9,0,0,1,102,27.08a9.75,9.75,0,0,1-1.63-3.16A12.86,12.86,0,0,1,99.77,20a12.34,12.34,0,0,1,.59-3.86A9.5,9.5,0,0,1,102,13.06,8,8,0,0,1,104.58,11a7.13,7.13,0,0,1,3.25-.76,6.44,6.44,0,0,1,2,.3,8.84,8.84,0,0,1,2,1c.6.41,1.6,1.28,1.6,1.28V1.17a1.11,1.11,0,0,1,1-1.17h2.08a1.11,1.11,0,0,1,1,1.17V28.31A1.11,1.11,0,0,1,116.62,29.47ZM104,20a8.18,8.18,0,0,0,.3,2.18,6.19,6.19,0,0,0,.88,2,4.9,4.9,0,0,0,1.49,1.41,4,4,0,0,0,2.11.54,3.88,3.88,0,0,0,2-.53,5.19,5.19,0,0,0,1.54-1.38,6.34,6.34,0,0,0,1-1.93,7.31,7.31,0,0,0,.33-2.16,7.56,7.56,0,0,0-.33-2.19,6.57,6.57,0,0,0-1-1.95,5.55,5.55,0,0,0-1.54-1.4,3.89,3.89,0,0,0-2-.54,4.1,4.1,0,0,0-2.11.52A4.5,4.5,0,0,0,105.17,16a6.24,6.24,0,0,0-.88,1.92A8.06,8.06,0,0,0,104,20Z"
              />
              <path
                className="cls-1"
                d="M118.66,20a10.88,10.88,0,0,1,.71-4,9.55,9.55,0,0,1,1.92-3.1,8.25,8.25,0,0,1,2.87-2,9.13,9.13,0,0,1,7.06,0,8.43,8.43,0,0,1,2.87,2A9.9,9.9,0,0,1,136,16a11.09,11.09,0,0,1,.71,4,11.18,11.18,0,0,1-.71,4.05,9.88,9.88,0,0,1-1.92,3.14,8.77,8.77,0,0,1-2.87,2.05,8.79,8.79,0,0,1-7.06,0,8.56,8.56,0,0,1-2.87-2.05,9.53,9.53,0,0,1-1.92-3.14A11,11,0,0,1,118.66,20Zm4.22,0a8.59,8.59,0,0,0,.29,2.18,6.42,6.42,0,0,0,.88,2,5,5,0,0,0,1.49,1.41,4.53,4.53,0,0,0,4.29,0,4.9,4.9,0,0,0,1.49-1.41,6.42,6.42,0,0,0,.88-2,8.18,8.18,0,0,0,.3-2.18,8.06,8.06,0,0,0-.3-2.17,6.48,6.48,0,0,0-.88-1.92,4.5,4.5,0,0,0-1.49-1.39,4.68,4.68,0,0,0-4.29,0A4.6,4.6,0,0,0,124.05,16a6.48,6.48,0,0,0-.88,1.92A8.46,8.46,0,0,0,122.88,20Z"
              />
              <path
                className="cls-1"
                d="M150.52,15.33a.74.74,0,0,1-1.08,0,4.21,4.21,0,0,0-1-.72,4.07,4.07,0,0,0-2-.53,3.82,3.82,0,0,0-2,.53A4.59,4.59,0,0,0,143,16a6.34,6.34,0,0,0-.85,1.93,8.91,8.91,0,0,0-.28,2.17,8,8,0,0,0,.3,2.16,6.19,6.19,0,0,0,.88,1.93,4.61,4.61,0,0,0,1.47,1.38,3.85,3.85,0,0,0,2.06.53,4.73,4.73,0,0,0,1.94-.43,4.12,4.12,0,0,0,1-.65.8.8,0,0,1,1.15.11l1.36,1.55a1,1,0,0,1-.06,1.41,7.14,7.14,0,0,1-2,1.23,8.89,8.89,0,0,1-3.48.68,9.19,9.19,0,0,1-3.47-.66,8.09,8.09,0,0,1-2.87-1.95,9.32,9.32,0,0,1-1.94-3.12,11.54,11.54,0,0,1-.71-4.17,11.38,11.38,0,0,1,.71-4.1,9.44,9.44,0,0,1,1.92-3.12,8.33,8.33,0,0,1,2.82-2,8.58,8.58,0,0,1,7,.07,7.24,7.24,0,0,1,2.06,1.39,1,1,0,0,1,0,1.42Z"
              />
              <path
                className="cls-1"
                d="M155.47,28h-.62v.88c0,.07,0,.14,0,.2a.43.43,0,0,0,0,.16.24.24,0,0,0,.1.1.4.4,0,0,0,.17,0h.15a.26.26,0,0,0,.14-.06v.68a1.05,1.05,0,0,1-.24.06L155,30a1.66,1.66,0,0,1-.33,0,.77.77,0,0,1-.25-.14.64.64,0,0,1-.18-.25,1,1,0,0,1-.06-.37V28h-.45V27.3h.45v-.78h.69v.78h.62Z"
              />
              <path
                className="cls-1"
                d="M155.8,27.3h.66v.36h0l.1-.15a.93.93,0,0,1,.14-.14,1.11,1.11,0,0,1,.19-.09.59.59,0,0,1,.23,0,.82.82,0,0,1,.42.11.68.68,0,0,1,.28.36.84.84,0,0,1,.29-.36.73.73,0,0,1,.42-.11.78.78,0,0,1,.39.09.69.69,0,0,1,.24.24,1.08,1.08,0,0,1,.13.37,2.15,2.15,0,0,1,0,.45V30h-.69V28.41a.79.79,0,0,0-.07-.32.25.25,0,0,0-.24-.13.4.4,0,0,0-.2,0,.4.4,0,0,0-.13.13.62.62,0,0,0-.07.19.9.9,0,0,0,0,.23V30h-.7V28.38a1.18,1.18,0,0,0,0-.2.29.29,0,0,0-.09-.16.24.24,0,0,0-.18-.06.38.38,0,0,0-.22.06.32.32,0,0,0-.13.15,1.08,1.08,0,0,0-.05.21,2.11,2.11,0,0,0,0,.25V30h-.69Z"
              />
              <path
                // className="cls-2"
                d="M16.58,23.73h3.26a1.31,1.31,0,0,0,1.26-1L25.23,7.55A1.31,1.31,0,0,0,24,5.9H20.71a1.31,1.31,0,0,0-1.26,1L15.32,22.08A1.31,1.31,0,0,0,16.58,23.73Z"
                fill={fillOpaq}
              />
              <path
                // className="cls-2"
                d="M5.82,22.76,10,7.55A1.31,1.31,0,0,0,8.69,5.9H5.43a1.32,1.32,0,0,0-1.26,1L.05,22.08a1.31,1.31,0,0,0,1.26,1.65H4.56A1.31,1.31,0,0,0,5.82,22.76Z"
                fill={fillOpaq}
              />
              <path
                // className="cls-2"
                d="M11.27,15.16h3.25a1.3,1.3,0,0,0,1.26-1l1.81-6.65A1.31,1.31,0,0,0,16.33,5.9H13.07a1.31,1.31,0,0,0-1.26,1L10,13.51A1.31,1.31,0,0,0,11.27,15.16Z"
                fill={fillOpaq}
              />
              <path
                className="cls-1"
                d="M13.37,16.43H10.11a1.32,1.32,0,0,0-1.26,1L4.73,32.61A1.3,1.3,0,0,0,6,34.25H9.24a1.3,1.3,0,0,0,1.26-1l4.13-15.21A1.31,1.31,0,0,0,13.37,16.43Z"
              />
              <path
                className="cls-1"
                d="M28.65,16.43H25.39a1.32,1.32,0,0,0-1.26,1L20,32.61a1.3,1.3,0,0,0,1.26,1.64h3.26a1.31,1.31,0,0,0,1.26-1l4.13-15.21A1.31,1.31,0,0,0,28.65,16.43Z"
              />
              <path
                className="cls-1"
                d="M18.68,25H15.43a1.3,1.3,0,0,0-1.26,1l-1.81,6.65a1.3,1.3,0,0,0,1.26,1.64h3.26a1.31,1.31,0,0,0,1.26-1l1.8-6.65A1.3,1.3,0,0,0,18.68,25Z"
              />
            </g>
          </g>
        </svg>
      )}

      {((!isEditor && isTop && pathname === '/') || isFeaturePage) && (
        <LogoWrap>
          <WhiteLogo />
        </LogoWrap>
      )}

      {((!logoColor && !isEditor && pathname !== '/' && !isFeaturePage) ||
        (logoColor && !isTop) ||
        (pathname === '/' && !isTop)) &&
        getPurpleLogo()}
    </>
  );
};

export default SVGLogo;
